window.FlashyProductRecommendations = class FlashyProductRecommendations {
  constructor(popupId, productsContainer = 'flashy-homepage-recommendations-custom', title = '') {
    this.popupId = popupId;
    this.swiperContainer = productsContainer;
    this.container = document.getElementById(productsContainer);
    this.title = title;
  }

  // Fetch product recommendations
  async fetchRecommendations() {
    try {
      const recommendations = await flashy.recommendations.get(this.popupId);
      return this.getItemIds(recommendations.products);
    } catch (error) {
      console.log("Error fetching flashy recommendations:", error);
    }
  }

  // Fetch product details from Shopify
  async fetchProductDetails(productNumericIds) {
    const productGlobalIds = productNumericIds.map(id => `gid://shopify/Product/${id}`);

    const productQuery = `
      query ProductsQuery($ids: [ID!]!) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            handle
            descriptionHtml
            createdAt
            productType
            vendor
            tags
            images(first: 2) {
              edges {
                node {
                  id
                  originalSrc
                  altText
                }
              }
            }
            options {
              id
              name
              values
            }
            variants(first: 100) {
              edges {
                node {
                  id
                  title
                  priceV2 {
                    amount
                    currencyCode
                  }
                  image {
                    originalSrc
                    altText
                  }
                  availableForSale
                  sku
                  compareAtPriceV2 {
                    amount
                    currencyCode
                  }
                  salePrice: priceV2 {
                    amount
                    currencyCode
                  }
                  selectedOptions {
                    name
                    value
                  }
                }
              }
            }
            collections(first: 20) {
              edges {
                node {
                  metafield(namespace: "custom", key: "collection_badgess") {
                    value
                  }
                }
              }
            }
          }
        }
      }`;

    try {
      const response = await fetch(`//${window.Shopify.shop}/api/2024-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1de1a941321f505e6067eaa4930fa636',
        },
        body: JSON.stringify({
          query: productQuery,
          variables: { ids: productGlobalIds },
        }),
      });

      const { data, errors } = await response.json();

      data.nodes.forEach(product => {
        if (product)
          product.options = product.options.find((option) => option.name === "Color");
      })
      
      if (errors) {
        console.error('GraphQL Errors:', errors);
        return null;
      }

      return data.nodes;
    } catch (error) {
      console.error('Fetch Error:', error);
      return null;
    }
  }

  async getProductTemplate(product) {
    let id = 1;
    let yotpoId = 1;
    if ( product ) {
      id = product.variants.edges[0].node.id.slice(29);
      yotpoId = product.id.slice(22);
    }
    let compareAtPriceV2 = '';
    if ( product.variants.edges[0].node.compareAtPriceV2 && product.variants.edges[0].node.compareAtPriceV2.amount !== '0.0') {
      compareAtPriceV2 = parseFloat(product.variants.edges[0].node.compareAtPriceV2.amount).toFixed(2) + " ₪";
    }
    let priceV2 = '';
    
    let badge = '';
    if ( product.variants.edges[0].node.priceV2 && product.variants.edges[0].node.priceV2.amount !== '0.0' ) {
      priceV2 = parseFloat(product.variants.edges[0].node.priceV2.amount).toFixed(2) + " ₪";

    }

    let secondImage = ''
    if (product.images.edges[1]) {
      secondImage += `<div class="color_variant_img grid-product__color-image"></div>`
      secondImage += `<img src="${product.images.edges[1].node.originalSrc}" class="motion-reduce secondary_image" loading="lazy" width="466" height="466">`
    }

    // Create an empty array to store unique color values for each product
    let seenColors = [];
    let colorsString = '<div class="grid-product__colors">'
    let colorCount = -1
    const maxColors = 4

    // Loop through the variants and options to extract unique color values
    product.variants.edges.forEach((variant, index) => {
      variant.node.selectedOptions.forEach(option => {
        if (option.name.toLowerCase().includes('color') && !seenColors.includes(option.value)) {
          seenColors.push(option.value); // Add the unique color to the array

          colorCount++;
          if (colorCount >= maxColors) return;
          
          // Create the color swatch HTML (use the option value as the color or get an image)
          let colorFileName = option.value.replace(/\s+/g, '-').toLowerCase(); // Convert to file-friendly name
          let colorImage = `https://www.dealcosmetics.co.il/cdn/shop/files/${colorFileName}_50x50.png`; // Example image URL
          let colorFallback = option.value.split(' ').pop().toLowerCase(); // Use the last part of the value as fallback color

          // https://www.dealcosmetics.co.il/cdn/shop/files/professional-lipliner-xoxo-01_50x50.png | EXAMPLE IMAGE LINK
          
          // Create the HTML for the swatch
          let colorSwatch = `
            <span class="color-swatch color-swatch--small color-swatch--${colorFileName}" 
              data-url="${variant.node.id}"
              style="background-color: ${colorFallback}; background-image: url(${colorImage});">
              <span class="visually-hidden">${option.value}</span>
            </span>
          `;
          
          colorsString += colorSwatch;
        }
      });
    });

    if (colorCount > maxColors)
      colorsString += `<small class="color-swatch__more">+${colorCount + 1}</small>`
    colorsString += '</div>'

    if (seenColors.length === 0)
      colorsString = ''

    let quick_add_button = ``

    if (seenColors.length === 0) {
      quick_add_button += `<button type="button" href="#" class="add-to-cart product-form__submit-ajax quick-add-btn js-quick-add-btn" title="הוספה לסל" data-id="${id}">
        <svg class="plus-icon" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64"><path stroke="#fff" class="cls-1" d="M32 9v46m23-23H9"></path></svg>
        <span class="btn"></span>
      </button>`
    } else {
      quick_add_button += `<button type="button" href="#" class="js-modal-open-quick-add js-quick-add-form add-to-cart product-form__submit-ajax quick-add-btn" title="הוספה לסל" tab-index="-1">
        <svg class="plus-icon" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 64 64"><path stroke="#fff" class="cls-1" d="M32 9v46m23-23H9"></path></svg>
      </button>`
    }

  let product_badges = `<div class="card__badge bottom left">`
  
  for (let col of product.collections.edges) {
    if (col.node.metafield != null) {
      var metaobjectQuery = `query fetchMetaobject($ids: [ID!]!) {
                                nodes(ids: $ids) {
                                  ... on Metaobject {
                                    id
                                    fields {
                                      key
                                      value
                                      type
                                    }
                                  }
                                }
                              }`
      var idsArray = await JSON.parse(col.node.metafield.value)

      const response = await fetch(`//${window.Shopify.shop}/api/2024-10/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '1de1a941321f505e6067eaa4930fa636',
        },
        body: JSON.stringify({
          query: metaobjectQuery,
          variables: { ids: idsArray },
        }),
      });

      const { data, errors } = await response.json();
      if (data != null) {
         for (let badge of data.nodes) {
           product_badges += `<span
                    class="badge badge--bottom-left"
                    style="background: ${ badge.fields[0].value }; color: ${ badge.fields[2].value }"
                  >
                    ${ badge.fields[1].value }
                  </span>`
         }
      }
    } 
  }

  product_badges += "</div>"
    
    return `
<li data-product-id="${id}" class="swiper-slide">
  <div class="card-wrapper product-card-wrapper underline-links-hover grid-product" data-product-handle="${ product.handle }" data-product-id="${product.id}">
    ${quick_add_button}
    <div class="card card--standard card--media" style="--ratio-percent: 100%;">
      <div class="card__inner color-background-1 gradient ratio" style="--ratio-percent: 100%;">
      <div class="card__media">
        <div class="media media--transparent media--hover-effect">
          <img src="${product.images.edges[0].node.originalSrc}" class="motion-reduce" loading="lazy" width="466" height="466">
          ${secondImage}
        </div>
      </div>
      <div class="card__content">
        <div class="card__information">
          <h3 class="card__heading">
            <a href="/products/${product.handle}" id="StandardCardNoMediaLink-template--17523177980163__featured-collection-7700035600643" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--17523177980163__featured-collection-7700035600643 NoMediaStandardBadge-template--17523177980163__featured-collection-7700035600643">
              ${product.title}
            </a>
          </h3>
        </div>
        ${product_badges}
        ${badge}
      </div>
    </div>
    <div class="card__content">
      <div class="card__information">
        ${colorsString}
        <h3 class="card__heading h5" id="title-template--17523177980163__featured-collection-7700035600643">
          <a href="/products/${product.handle}" class="full-unstyled-link" aria-labelledby="CardLink-template--17523177980163__featured-collection-7700035600643 Badge-template--17523177980163__featured-collection-7700035600643">
            ${product.title}
          </a>
        </h3>
        <div class="yotpo bottomLine yotpo-small" data-product-id="${yotpoId}" ></div>
        <div class="card-information 1">
          <span class="visually-hidden">Vendor:</span>
          <div class="caption-with-letter-spacing light">${product.vendor}</div><span class="caption-large light"></span>
            <div class="price  price--on-sale">
              <div class="price__container"><div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">
                  ${compareAtPriceV2}
                </span>
              </div>
              <div class="price__sale">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                  <span>
                    <s class="price-item price-item--regular" data-debug="4000">${compareAtPriceV2}</s>
                  </span>
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">
                    ${priceV2}
                  </span>
                </div>
                <small class="unit-price caption hidden">
                  <span class="visually-hidden">Unit price</span>
                  <span class="price-item price-item--last">
                    <span></span>
                    <span aria-hidden="true">/</span>
                    <span class="visually-hidden">&nbsp;per&nbsp;</span>
                    <span>
                    </span>
                  </span>
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</li>`;
  }


  // Render product details
  async displayProducts() {
    const recommendations = await this.fetchRecommendations();
    if (!recommendations) return
    
    const productsDetails = await this.fetchProductDetails(recommendations);
    if ( this.container ) {
      this.container.innerHTML = '';
    }
    

    if ( this.title !== '') {
      var sp1 = document.createElement("h4");
      sp1.classList.add('flashy-section-title')
      
      sp1.innerHTML = this.title;
      // Get a reference to the parent element
      var parentDiv = this.container.parentNode;
      if ( ! parentDiv.querySelector('h4') ) {
        // Insert the new element into the DOM before sp2
        parentDiv.insertBefore(sp1, this.container);
      }
    }


    await productsDetails.forEach(async product => {
      if ( ! product ) return '';
      const productHTML = await this.getProductTemplate(product);

      // Insert the product HTML directly into the container
      this.container.insertAdjacentHTML('beforeend', productHTML);

      const lastProductItem = this.container.lastElementChild;

      // Add event listener for the Click or Add to Cart events
      const links = lastProductItem.querySelectorAll('a'); // Selects all <a> tags within the item

      // For any links events
      links.forEach(link => {
        link.addEventListener('click', (e) => {
          this.trackProductInteraction('amplify:Click', this.getItemId(product.id));
        });
      });

      //If you are using Add To Cart directly from the product
      
      lastProductItem.querySelector('.add-to-cart').addEventListener('click', (e) => {
      this.trackProductInteraction('amplify:AddToCart', this.getItemId(product.id), product.variants.edges[0].node.priceV2.amount);
      });    
    });
    new theme.QuickAdd(this.container);
    
    let isFlashySlider = this.container.closest('.flashy-slider');
    if ( isFlashySlider ) {
      isFlashySlider.classList.remove('hidden');
    }

    $('.collection__title h2').show()

    if ( this.swiperContainer === 'cart-recomendations' ) {
      let swiperContainer = this.container.closest('div');
      let galleryMain = new Swiper(swiperContainer, {
        // loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        freeMode: true,
        // slideToClickedSlide: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          1: {
            slidesPerView: 2.1, 
            spaceBetween: 10, 
          },
          768: {
            slidesPerView: 2.2, 
            spaceBetween: 10, 
          }
        }
      }); 
   } else if (this.swiperContainer === 'flashy-cart-recommendations') {
      let swiperContainer = this.container.closest('div');
      let galleryMain = new Swiper(swiperContainer, {
        // loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        freeMode: true,
        // slideToClickedSlide: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          1: {
            slidesPerView: 2, 
            spaceBetween: 10, 
          },
          768: {
            slidesPerView: 3, 
            spaceBetween: 10, 
          }
        }
      }); 
    } else {
      let swiperContainer = this.container.closest('div');
      let galleryMain = new Swiper(swiperContainer, {
        // loop: true,
        slidesPerView: 5,
        spaceBetween: 10,
        // slideToClickedSlide: true,
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // },
        breakpoints: {
          1: {
            slidesPerView: 2.1, 
            spaceBetween: 10, 
          },
          768: {
            slidesPerView: 5, 
            spaceBetween: 10, 
          }
        }
      });
    }
    // var api = new Yotpo.API(yotpo);
    // api.refreshWidgets();
    // new theme.QuickAdd(this.container);
  }

  // Track product interactions
  trackProductInteraction(eventType, productId, value = null, currency = 'ILS') {
    const eventData = {
      'popup_id': this.popupId,
      'content_ids': [productId]
    };

    if (eventType === 'amplify:AddToCart') {
      eventData.value = value; // Assuming value is provided for Add to Cart events
      eventData.currency = currency;
    }

    flashy(eventType, eventData);
  }

  getItemIds(obj) {
    const ids = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && obj[key] !== null && 'id' in obj[key]) {
        ids.push(obj[key].id);
      }
    }
    return ids;
  }

  getItemId(globalId) {
    return globalId.split('/').pop();
  }

  // Initialize the recommendations display
  init(theme) {
    this.displayProducts();
  }
}